<template>
  <v-card color="primary" class="rounded-sm">
    <v-card-text v-if="editArma">
      <v-container>
        <v-form v-model="armaForm" ref="form">
          <v-row>
            <v-col cols="12">
              <div class="text-subtitle-1">Tipo y clase</div>
            </v-col>
            <v-col cols="3">
              <BaseInput label="Número económico" v-model.number="editArma.noEconomico" type="number"></BaseInput>
            </v-col>
            <v-col cols="3">
              <BaseSelect
                v-model="editArma.fk_idTipo"
                @change="editArma.fk_idClase = null"
                :items="tipoArma"
                :rules="required"
              >
                <template v-slot:label>Tipo de arma <span class="red--text">*</span> </template>
              </BaseSelect>
            </v-col>
            <v-col cols="3">
              <BaseSelect v-model="editArma.fk_idClase" :items="catalogoTipoArma" :rules="required">
                <template v-slot:label>Clase <span class="red--text">*</span> </template>
              </BaseSelect>
            </v-col>
            <v-col cols="3">
              <BaseSelect label="Calibre" v-model="editArma.fk_idCalibre" :items="calibre" :rules="required">
                <template v-slot:label>Calibre <span class="red--text">*</span> </template>
              </BaseSelect>
            </v-col>
            <v-col cols="12">
              <div class="text-subtitle-1">Marca y modelo</div>
            </v-col>
            <v-col cols="6">
              <BaseSelect
                label="Marca"
                v-model="editArma.fk_idMarca"
                @change="triggerFetchModeloArmas($event)"
                :items="marcaArma"
                :rules="required"
              >
                <template v-slot:label>Marca <span class="red--text">*</span> </template>
              </BaseSelect>
            </v-col>
            <v-col cols="6">
              <BaseSelect
                v-model="editArma.fk_idModelo"
                :items="catalogoModeloArma"
                :disabled="loadingModelos"
                :rules="required"
              >
                <template v-slot:label>Modelo <span class="red--text">*</span> </template>
              </BaseSelect>
            </v-col>
            <v-col cols="6">
              <BaseInput label="Matrícula" v-model="editArma.matricula"></BaseInput>
            </v-col>
            <v-col cols="6">
              <BaseSelect v-model="editArma.fk_idCatProcedenciaArma" :items="procedencia" :rules="required">
                <template v-slot:label>Procedencia <span class="red--text">*</span> </template>
              </BaseSelect>
            </v-col>
            <v-col cols="4">
              <BaseInput label="Folio C" v-model="editArma.folioC"></BaseInput>
            </v-col>
            <v-col cols="4">
              <BaseInput label="Folio D" v-model="editArma.folioD"></BaseInput>
            </v-col>
            <v-col cols="4">
              <BaseInput label="Armero" v-model="editArma.armeros"></BaseInput>
            </v-col>
            <v-col cols="4">
              <BaseInput
                v-model="editArma.fechaAltaLoc"
                v-mask="'##/##/####'"
                hint="Formato de fecha: DD/MM/YYYY"
                :rules="dateRules"
              >
                <template v-slot:label>Fecha de alta en LOC <span class="red--text">*</span> </template>
              </BaseInput>
            </v-col>
            <v-col cols="4">
              <BaseInput
                v-model="editArma.fechaCompra"
                v-mask="'##/##/####'"
                hint="Formato de fecha: DD/MM/YYYY"
                :rules="dateRules"
              >
                <template v-slot:label>Fecha de compra <span class="red--text">*</span> </template>
              </BaseInput>
            </v-col>
            <v-col cols="4">
              <BaseInput
                v-model="editArma.puestaDisposición"
                v-mask="'##/##/####'"
                hint="Formato de fecha: DD/MM/YYYY"
                :rules="dateRules"
              >
                <template v-slot:label>Fecha de puesta a disposición <span class="red--text">*</span> </template>
              </BaseInput>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions class="justify-center">
      <TextButton @click="triggerUpdateArma()" :loading="loading" :disabled="loading || !armaForm">
        Guardar cambios
      </TextButton>
    </v-card-actions>
  </v-card>
</template>
<script>
import moment from 'moment'
import _ from 'lodash'
import { mapGetters, mapActions } from 'vuex'
import BaseSelect from '../../../base/BaseSelect.vue'
import BaseInput from '../../../base/BaseInput.vue'
import TextButton from '../../../base/TextButton.vue'

export default {
  components: {
    BaseSelect,
    BaseInput,
    TextButton,
  },
  props: {
    active: {
      type: Boolean,
    },
  },

  data() {
    return {
      armaForm: true,
      loading: false,
      loadingModelos: false,
      dateRules: [
        (v) => !!v || 'Este campo es requerido.',
        (v) => {
          var date = moment(v, 'DD/MM/YYYY')
          return moment(date, 'DD/MM/YYYY').isValid() || 'El formato de fecha debe ser DD/MM/YYYY'
        },
      ],
      required: [(v) => !!v || 'Este campo es requerido.'],
    }
  },

  computed: {
    ...mapGetters('modeloArma', {
      modeloArma: 'getModelosArmas',
    }),
    ...mapGetters('claseArma', {
      clasesArmaCorta: 'getClasesArmaCorta',
      clasesArmaLarga: 'getClasesArmaLarga',
    }),
    ...mapGetters('tipoArma', {
      tipoArma: 'getTipoArmas',
    }),
    ...mapGetters('calibre', {
      calibre: 'getCalibres',
    }),
    ...mapGetters('procedencia', {
      procedencia: 'getProcedencia',
    }),
    ...mapGetters('marcaArma', {
      marcaArma: 'getMarcaArma',
    }),
    ...mapGetters('arma', {
      editArma: 'getSelectedArma',
    }),

    getClaseArma() {
      if (this.editArma && typeof this.editArma.fk_idTipo !== 'undefined' && this.editArma.fk_idTipo !== null) {
        return this.editArma.fk_idTipo == 2 ? this.clasesArmaCorta : this.clasesArmaLarga
      }
      return []
    },
    catalogoTipoArma() {
      return this.getClaseArma.map((tipo) => ({
        id: tipo.id,
        title: tipo.clase,
      }))
    },

    catalogoModeloArma() {
      if (this.editArma && this.editArma.fk_idMarca) {
        return this.modeloArma
          .filter((modelo) => modelo.fk_idMarca === this.editArma.fk_idMarca)
          .map((modelo) => ({
            id: modelo.id,
            title: modelo.modelo,
          }))
      }
      return []
    },
  },

  methods: {
    ...mapActions('claseArma', ['fetchClasesArma']),
    ...mapActions('modeloArma', ['fetchModeloArmas']),
    ...mapActions('arma', ['updateArma', 'fetchArmas']),

    async triggerFetchModeloArmas(event) {
      this.loadingModelos = true
      this.editArma.fk_idModelo = null
      await this.fetchModeloArmas(event)
      this.loadingModelos = false
    },

    async triggerUpdateArma() {
      this.loading = true
      await this.updateArma(this.editArma)
      await this.fetchArmas()
      this.loading = false
      this.$emit('close')
    },
  },
}
</script>
